import { Megaphone } from 'lucide-react';
import { SocialPlatform } from '@mg/shared';
import { PLATFORM_META } from '../social/platforms';
import { cn } from '../../lib/cn';

/**
 * Small inline platform glyph for a content card — a branded tile with the platform's icon, or a
 * generic megaphone when a social item has no specific platform set. `size` controls BOTH the tile
 * and the fallback so callers get a consistent footprint (the `cn` util is plain join, not
 * tailwind-merge, so a raw className can't reliably resize it — use `size`).
 */
export function PlatformIcon({
  platform,
  size = 'md',
}: {
  platform: SocialPlatform | null;
  size?: 'sm' | 'md';
}) {
  const tile = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';
  const glyph = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';

  if (!platform) {
    return (
      <span className={cn('inline-flex shrink-0 items-center justify-center', tile)} title="Post">
        <Megaphone className={cn(glyph, 'text-ink-faint')} aria-hidden />
      </span>
    );
  }
  const meta = PLATFORM_META[platform];
  const Icon = meta.Icon;
  return (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center rounded-md', tile, meta.tile)}
      title={meta.label}
      aria-label={meta.label}
    >
      <Icon className={glyph} />
    </span>
  );
}
